import { useEffect, useState } from 'react';
import { Card } from 'antd';

import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { Card as CustomCard } from './components/Card';

import { Container, Content, SearchBar } from './styles';
import { FiSearch } from 'react-icons/fi';
import { apiNode } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { SuccessEnterLeagueModal } from './components/SuccessEnterLeagueModal';
import { normalizeString } from '../../utils/normalizeString';

interface InviteProps {
  id: number;
  liga: {
    id: number;
    nome: string;
    privada: boolean;
  };
}

interface InviteResponseAPI {
  convites: InviteProps[];
}

export const LeagueUserNotifications = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [invites, setInvites] = useState<InviteProps[]>([]);
  const [filteredInvites, setFilteredInvites] = useState<InviteProps[]>([]);
  const [selectedInvite, setSelectedInvite] = useState<InviteProps>(
    {} as InviteProps
  );

  const [isSuccessAcceptUserModalOpen, setIsSuccessAcceptUserModalOpen] =
    useState(false);

  useEffect(() => {
    try {
      setIsLoading(true);
      const getInvites = async () => {
        const response = await apiNode.get<InviteResponseAPI>('/convites');

        setInvites(response.data.convites);
        setFilteredInvites(response.data.convites);
        setIsLoading(false);
      };

      getInvites();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, [navigate]);

  const handleOpenSuccessModal = (request: InviteProps) => {
    setIsSuccessAcceptUserModalOpen(true);
    setSelectedInvite(request);
  };

  const updateInvitesList = (id: number) => {
    let newInvitesList: InviteProps[] = [];

    invites.forEach((invite) => {
      if (invite.id !== id) {
        newInvitesList.push(invite);
      }
    });

    setFilteredInvites(newInvitesList);
  };

  const filterInvitesByLeagueName = (word: string) => {
    const newFilteredInvitesList: InviteProps[] = [];

    invites.forEach((invite) => {
      if (normalizeString(invite.liga.nome).includes(normalizeString(word))) {
        newFilteredInvitesList.push(invite);
      }
    });

    setFilteredInvites(newFilteredInvitesList);
  };

  return (
    <Container>
      <Header />

      <Content>
        <span>
          <h1>Notificações</h1>

          <SearchBar>
            <FiSearch size={15} />
            <input
              type="text"
              placeholder="Encontre um convite"
              onChange={(event) =>
                filterInvitesByLeagueName(event.target.value)
              }
            />
          </SearchBar>
        </span>

        <div>
          {isLoading && (
            <>
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
            </>
          )}

          {!isLoading &&
            filteredInvites.length > 0 &&
            filteredInvites.map((invite) => (
              <CustomCard
                key={invite.id}
                invite={invite}
                openSuccessModal={handleOpenSuccessModal}
                updateInvitesList={updateInvitesList}
              />
            ))}

          {!isLoading && filteredInvites.length < 1 && (
            <h1>Você não possui nenhuma notificação</h1>
          )}
        </div>
      </Content>

      <Footer />

      <SuccessEnterLeagueModal
        isOpen={isSuccessAcceptUserModalOpen}
        invite={selectedInvite}
      />
    </Container>
  );
};
